import React, { useState, useRef, lazy } from 'react';
import { Heart, MessageCircle, Share2, Bookmark, MoreHorizontal, Lock, Gift, MapPin, ChevronLeft, Bell, BellOff, CheckCircle, Flame, ArrowLeft, ShoppingBag, Image as ImageIcon, Mic, Flag, Target, Music, Award, DollarSign, Send, ChevronRight, Video, Sparkles, X } from 'lucide-react';
import { VideoGenerationUpsell } from './VideoGenerationUpsell';
interface MiaKhalifaAngelFeedProps {
  onBack: () => void;
}
export const MiaKhalifaAngelFeed: React.FC<MiaKhalifaAngelFeedProps> = ({
  onBack
}) => {
  const [activeTab, setActiveTab] = useState('all');
  const [isFollowing, setIsFollowing] = useState(false);
  const [likedPosts, setLikedPosts] = useState<Record<string, boolean>>({});
  const [showNotificationOptions, setShowNotificationOptions] = useState(false);
  const [notificationEnabled, setNotificationEnabled] = useState(false);
  const [showPollResults, setShowPollResults] = useState(false);
  const [pollVote, setPollVote] = useState<string | null>(null);
  const [commentText, setCommentText] = useState('');
  const [showUnlockModal, setShowUnlockModal] = useState(false);
  const [unlockPostId, setUnlockPostId] = useState<string | null>(null);
  const [showImageGeneratorModal, setShowImageGeneratorModal] = useState(false);
  const [showVideoUpsellModal, setShowVideoUpsellModal] = useState(false);
  const tabsRef = useRef<HTMLDivElement>(null);
  const tabs = [{
    id: 'all',
    label: 'All',
    icon: <Flame size={14} data-id="element-10038" />
  }, {
    id: 'media',
    label: 'Media',
    icon: <ImageIcon size={14} data-id="element-10039" />
  }, {
    id: 'voice',
    label: 'Voice',
    icon: <Mic size={14} data-id="element-10040" />
  }, {
    id: 'missions',
    label: 'Missions',
    icon: <Target size={14} data-id="element-10041" />
  }, {
    id: 'polls',
    label: 'Polls',
    icon: <Flag size={14} data-id="element-10042" />
  }, {
    id: 'upsells',
    label: 'Upsells',
    icon: <Lock size={14} data-id="element-10043" />
  }, {
    id: 'rewards',
    label: 'Rewards',
    icon: <Award size={14} data-id="element-10044" />
  }, {
    id: 'shop',
    label: 'Shop',
    icon: <ShoppingBag size={14} data-id="element-10045" />
  }];
  const scrollTabs = (direction: 'left' | 'right') => {
    if (tabsRef.current) {
      const scrollAmount = direction === 'left' ? -200 : 200;
      tabsRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  const toggleFollow = () => {
    setIsFollowing(!isFollowing);
  };
  const toggleNotification = () => {
    setNotificationEnabled(!notificationEnabled);
    setShowNotificationOptions(false);
  };
  const toggleLike = (postId: string) => {
    setLikedPosts(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };
  const handlePollVote = (option: string) => {
    setPollVote(option);
    setShowPollResults(true);
  };
  const handleSubmitComment = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would submit the comment
    setCommentText('');
  };
  const handleUnlock = (postId: string) => {
    setUnlockPostId(postId);
    setShowUnlockModal(true);
  };
  const confirmUnlock = () => {
    // Here you would handle the actual token transaction
    setShowUnlockModal(false);
  };
  const posts = [{
    id: 'post1',
    type: 'premium_content',
    content: "Feeling festive in my special outfit... want to see what's underneath? 🎁 Unwrap me for a holiday treat you won't forget...",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/c9u3gUPe4JsXpyUu5nHEjr/mia_khalifa_1.png',
    likes: 3452,
    comments: 287,
    time: '1h ago',
    locked: true,
    price: 8,
    location: 'My Bedroom',
    hashtags: ['#festive', '#unwrapme', '#exclusive', '#naughty']
  }, {
    id: 'post2',
    type: 'poll',
    content: "Going to a football game this weekend. Which outfit should I wear to catch everyone's attention? 🏈",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wa8aw3EX126n2GWo67428z/mia_khalifa_2.png',
    likes: 2789,
    comments: 412,
    time: '3h ago',
    location: 'Game Day Prep',
    poll: {
      options: [{
        text: 'This tied crop top 👚',
        percentage: 75
      }, {
        text: 'Something more revealing 🔥',
        percentage: 25
      }],
      endsIn: '2 hours'
    },
    hashtags: ['#gameday', '#sportsfan', '#fashion', '#whattowear']
  }, {
    id: 'post3',
    type: 'market_item',
    content: "So many of you asked about this pink shirt I was wearing in my last selfie... I've worn it all week and now it could be yours 😘",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyruyE796b4NMnJ7rEMEeZ/mia_khalifa_3.png',
    likes: 1876,
    comments: 243,
    time: '1d ago',
    location: 'Lounging at Home',
    product: {
      name: "Mia's Worn Pink Shirt",
      description: 'My favorite pink shirt, worn all week',
      price: 40,
      status: 'Limited - Only 1 Available'
    },
    hashtags: ['#worn', '#intimate', '#closetsale', '#limitedoffer']
  }, {
    id: 'post4',
    type: 'voice_note',
    content: 'Recorded this just for you while lying in bed... listen with headphones to hear all the details 🎧',
    likes: 4231,
    comments: 512,
    time: '2d ago',
    location: 'Late Night',
    audioWaveform: [0.2, 0.5, 0.3, 0.8, 0.4, 0.6, 0.3, 0.5, 0.7, 0.8, 0.5, 0.3, 0.6, 0.4, 0.2],
    duration: '0:42',
    hashtags: ['#voice', '#whisper', '#asmr', '#intimate']
  }];
  // Filter posts based on active tab
  const filteredPosts = posts.filter(post => {
    if (activeTab === 'all') return true;
    if (activeTab === 'media' && (post.type === 'image' || post.type === 'premium_content')) return true;
    if (activeTab === 'voice' && post.type === 'voice_note') return true;
    if (activeTab === 'polls' && post.type === 'poll') return true;
    if (activeTab === 'upsells' && post.type === 'premium_content') return true;
    if (activeTab === 'shop' && post.type === 'market_item') return true;
    return false;
  });
  return <section className="w-full max-w-[860px] mx-auto px-4 space-y-4 angel-feed-container" data-id="element-10046">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-gray-950/90 backdrop-blur-sm p-3 flex items-center justify-between border-b border-gray-800" data-id="element-10047">
        <div className="flex items-center gap-4" data-id="element-10048">
          <button className="p-2 rounded-full hover:bg-gray-800" onClick={() => {
          // Navigate back to AllAngelsGrid
          const navigateEvent = new CustomEvent('navigate', {
            detail: {
              section: 'all_angels'
            }
          });
          document.dispatchEvent(navigateEvent);
          // Still call the original onBack for any cleanup
          onBack();
        }} data-id="element-10049">
            <ArrowLeft size={20} data-id="element-10050" />
          </button>
          <div data-id="element-10051">
            <h1 className="font-bold text-lg" data-id="element-10052">Mia Khalifa</h1>
            <p className="text-xs text-gray-400" data-id="element-10053">4.2M Followers</p>
          </div>
        </div>
        <div className="flex items-center gap-2" data-id="element-10054">
          <button className="flex items-center gap-1 px-3 py-1.5 bg-gray-800 rounded-full text-white text-xs font-medium" onClick={() => setShowImageGeneratorModal(true)} data-id="element-10055">
            <ImageIcon size={12} className="text-pink-400" data-id="element-10056" />
            <span data-id="element-10057">Generate Image</span>
          </button>
          <button className="flex items-center gap-1 px-3 py-1.5 bg-gray-800 rounded-full text-white text-xs font-medium" onClick={() => setShowVideoUpsellModal(true)} data-id="element-10058">
            <Video size={12} className="text-pink-400" data-id="element-10059" />
            <span data-id="element-10060">Generate Video</span>
          </button>
          <div className="relative" data-id="element-10061">
            <button className="p-2 bg-gray-800 rounded-full hover:bg-gray-700" onClick={() => setShowNotificationOptions(!showNotificationOptions)} data-id="element-10062">
              {notificationEnabled ? <Bell size={20} data-id="element-10063" /> : <BellOff size={20} data-id="element-10064" />}
            </button>
            {showNotificationOptions && <div className="absolute right-0 mt-2 w-48 bg-gray-900 rounded-lg shadow-lg border border-gray-800 z-10" data-id="element-10065">
                <button className="w-full px-4 py-2 text-left hover:bg-gray-800 rounded-t-lg flex items-center gap-2" onClick={toggleNotification} data-id="element-10066">
                  {notificationEnabled ? <>
                      <BellOff size={16} data-id="element-10067" />
                      <span data-id="element-10068">Disable notifications</span>
                    </> : <>
                      <Bell size={16} data-id="element-10069" />
                      <span data-id="element-10070">Enable notifications</span>
                    </>}
                </button>
              </div>}
          </div>
          <button className={`px-4 py-1.5 rounded-full font-bold ${isFollowing ? 'bg-gray-800 text-white hover:bg-red-600 hover:text-white' : 'bg-gradient-to-r from-pink-600 to-purple-600 text-white hover:opacity-90'}`} onClick={toggleFollow} data-id="element-10071">
            {isFollowing ? 'Following' : 'Follow'}
          </button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-800 hover:bg-gray-700 transition-colors" data-id="element-10072">
            <Sparkles size={16} className="text-pink-400" data-id="element-10073" />
          </button>
        </div>
      </div>

      {/* Profile Header */}
      <div className="relative" data-id="element-10074">
        <div className="h-32 w-full bg-gradient-to-r from-pink-600 to-purple-600 rounded-t-xl" data-id="element-10075"></div>
        <div className="absolute -bottom-16 left-4 w-32 h-32 rounded-full border-4 border-gray-950 overflow-hidden" data-id="element-10076">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gPbfjPdLfzNbqrZitYWXeS/MiaKhalifa.jpg" alt="Mia Khalifa" className="w-full h-full object-cover image-high-quality" loading="lazy" data-id="element-10077" />
        </div>
      </div>

      {/* Profile Info */}
      <div className="mt-20 px-4 ml-36" data-id="element-10078">
        <div className="flex items-center gap-1" data-id="element-10079">
          <h2 className="text-xl font-bold" data-id="element-10080">Mia Khalifa</h2>
          <CheckCircle size={16} className="text-pink-400" fill="currentColor" data-id="element-10081" />
          <span className="text-sm font-normal text-pink-400 ml-2" data-id="element-10082">🔥💋</span>
        </div>
        <p className="text-gray-400" data-id="element-10083">@MiaKhalifa</p>
        <p className="mt-2" data-id="element-10084">
          Former adult star turned sports enthusiast. I'll show you my playful
          side that nobody else gets to see... 😘
        </p>
        <div className="flex gap-4 mt-3 text-sm" data-id="element-10085">
          <div className="flex items-center gap-1" data-id="element-10086">
            <span className="font-bold" data-id="element-10087">512</span>
            <span className="text-gray-400" data-id="element-10088">Following</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-10089">
            <span className="font-bold" data-id="element-10090">4.2M</span>
            <span className="text-gray-400" data-id="element-10091">Followers</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-10092">
            <span className="font-bold" data-id="element-10093">520</span>
            <span className="text-gray-400" data-id="element-10094">Intimacy XP</span>
          </div>
        </div>
      </div>

      {/* Filter Tabs */}
      <div className="mt-4 relative border-b border-gray-800" data-id="element-10095">
        <button className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-gray-900/80 rounded-full text-gray-400 hover:text-white" onClick={() => scrollTabs('left')} data-id="element-10096">
          <ChevronLeft size={18} data-id="element-10097" />
        </button>
        <div ref={tabsRef} className="flex overflow-x-auto scrollbar-hide px-8 py-1" data-id="element-10098">
          {tabs.map(tab => <button key={tab.id} className={`px-4 py-2 flex items-center gap-1.5 whitespace-nowrap rounded-full mx-1 ${activeTab === tab.id ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-800/50 text-gray-300 hover:bg-gray-800'}`} onClick={() => setActiveTab(tab.id)} data-id="element-10099">
              {tab.icon}
              <span data-id="element-10100">{tab.label}</span>
            </button>)}
        </div>
        <button className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-gray-900/80 rounded-full text-gray-400 hover:text-white" onClick={() => scrollTabs('right')} data-id="element-10101">
          <ChevronRight size={18} data-id="element-10102" />
        </button>
      </div>

      {/* Posts Feed */}
      <div className="space-y-4" data-id="element-10103">
        {filteredPosts.length > 0 ? filteredPosts.map(post => <div key={post.id} className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden animate-in fade-in duration-300 angel-feed-post shadow-md hover:shadow-xl hover:shadow-pink-600/5 transition-all duration-300" data-id="element-10104">
              {/* Post Header */}
              <div className="p-3 flex items-center gap-2 border-b border-gray-800" data-id="element-10105">
                <div className="w-10 h-10 rounded-full overflow-hidden" data-id="element-10106">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/c9u3gUPe4JsXpyUu5nHEjr/mia_khalifa_1.png" alt="Mia Khalifa" className="w-full h-full object-cover image-high-quality" loading="lazy" data-id="element-10107" />
                </div>
                <div data-id="element-10108">
                  <div className="flex items-center gap-1" data-id="element-10109">
                    <h3 className="font-medium" data-id="element-10110">Mia Khalifa</h3>
                    <CheckCircle size={14} className="text-blue-400" fill="currentColor" data-id="element-10111" />
                    <span className="text-xs text-gray-400" data-id="element-10112">• {post.time}</span>
                  </div>
                  {post.location && <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-10113">
                      <MapPin size={10} className="ml-1" data-id="element-10114" />
                      <span data-id="element-10115">{post.location}</span>
                    </div>}
                </div>
                <button className="ml-auto" data-id="element-10116">
                  <MoreHorizontal size={16} className="text-gray-400" data-id="element-10117" />
                </button>
              </div>

              {/* Post Content */}
              <div className="px-3 py-2" data-id="element-10118">
                <p className="text-sm" data-id="element-10119">{post.content}</p>
                {/* Hashtags */}
                {post.hashtags && <div className="text-xs text-pink-400 mt-1" data-id="element-10120">
                    {post.hashtags.join(' ')}
                  </div>}
              </div>

              {/* Post Media */}
              {(post.type === 'image' || post.type === 'market_item' || post.type === 'poll' && post.image) && post.image && <div className="aspect-square bg-gray-800" data-id="element-10121">
                    <img src={post.image} alt="Post" className="w-full h-full object-cover angel-post-image hover:scale-[1.02] transition-transform duration-300" sizes="(max-width: 768px) 100vw, 820px" loading="lazy" data-id="element-10122" />
                  </div>}

              {/* Premium Content */}
              {post.type === 'premium_content' && post.image && <div className="relative aspect-square bg-gray-800" data-id="element-10123">
                  <img src={post.image} alt="Locked Content" className="w-full h-full object-cover blur-sm angel-post-image" sizes="(max-width: 768px) 100vw, 820px" loading="lazy" data-id="element-10124" />
                  <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm" data-id="element-10125">
                    <Lock size={32} className="text-pink-400 mb-2" data-id="element-10126" />
                    <p className="text-center text-white font-medium" data-id="element-10127">
                      Unlock Exclusive Photo
                    </p>
                    <button className="mt-3 px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white font-medium flex items-center gap-2 hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={() => handleUnlock(post.id)} data-id="element-10128">
                      <span data-id="element-10129">Unlock for</span>
                      <span className="text-pink-200" data-id="element-10130">{post.price} 💎</span>
                    </button>
                  </div>
                </div>}

              {/* Poll */}
              {post.type === 'poll' && post.poll && <div className="p-3" data-id="element-10131">
                  <div className="space-y-2" data-id="element-10132">
                    {post.poll.options.map((option, i) => <button key={i} className={`w-full p-3 bg-gray-800 rounded-lg border ${pollVote === option.text ? 'border-pink-500' : 'border-gray-700 hover:border-pink-500'} transition flex justify-between items-center`} onClick={() => handlePollVote(option.text)} data-id="element-10133">
                        <span data-id="element-10134">{option.text}</span>
                        {(showPollResults || pollVote) && <span className="text-xs bg-gray-700 px-2 py-1 rounded-full" data-id="element-10135">
                            {option.percentage}%
                          </span>}
                      </button>)}
                    <p className="text-xs text-gray-400 mt-2" data-id="element-10136">
                      Voting ends in {post.poll.endsIn} • Results will shape
                      tomorrow's content
                    </p>
                  </div>
                </div>}

              {/* Voice Note */}
              {post.type === 'voice_note' && post.audioWaveform && <div className="p-3" data-id="element-10137">
                  <div className="p-3 bg-gray-800 rounded-lg border border-gray-700" data-id="element-10138">
                    <div className="flex items-center gap-3" data-id="element-10139">
                      <button className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-r from-pink-600 to-purple-600 text-white hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" data-id="element-10140">
                        <div className="ml-1" data-id="element-10141">▶</div>
                      </button>
                      <div className="flex-grow h-10 flex items-center" data-id="element-10142">
                        {post.audioWaveform.map((level, i) => <div key={i} className="w-1 mx-0.5 rounded-full bg-gradient-to-t from-pink-500/50 to-purple-500/50" style={{
                  height: `${level * 32}px`
                }} data-id="element-10143"></div>)}
                      </div>
                      <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-10144">
                        <span data-id="element-10145">{post.duration}</span>
                      </div>
                    </div>
                    <p className="text-xs text-gray-400 mt-2" data-id="element-10146">
                      🎧 Best experienced with headphones
                    </p>
                  </div>
                </div>}

              {/* Market Item */}
              {post.type === 'market_item' && post.product && <div className="p-3" data-id="element-10147">
                  <div className="p-3 bg-gradient-to-r from-pink-900/20 to-purple-900/20 rounded-lg border border-pink-800/30" data-id="element-10148">
                    <div className="flex items-center justify-between mb-2" data-id="element-10149">
                      <h4 className="font-medium" data-id="element-10150">{post.product.name}</h4>
                      <span className="text-pink-400 font-bold" data-id="element-10151">
                        {post.product.price} 💎
                      </span>
                    </div>
                    <p className="text-sm text-gray-300 mb-2" data-id="element-10152">
                      {post.product.description}
                    </p>
                    <div className="flex items-center justify-between" data-id="element-10153">
                      <span className="text-xs text-pink-300" data-id="element-10154">
                        {post.product.status}
                      </span>
                      <button className="px-3 py-1 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" data-id="element-10155">
                        Buy Now
                      </button>
                    </div>
                  </div>
                </div>}

              {/* Post Actions */}
              <div className="p-3" data-id="element-10156">
                <div className="flex items-center justify-between" data-id="element-10157">
                  <div className="flex items-center gap-3" data-id="element-10158">
                    <button className="flex items-center gap-1 group" onClick={() => toggleLike(post.id)} data-id="element-10159">
                      <Heart size={18} className={likedPosts[post.id] ? 'text-pink-500' : 'text-gray-400 group-hover:text-pink-400'} fill={likedPosts[post.id] ? 'currentColor' : 'none'} data-id="element-10160" />
                      <span className="text-xs" data-id="element-10161">
                        {likedPosts[post.id] ? post.likes + 1 : post.likes}
                      </span>
                    </button>
                    <button className="flex items-center gap-1" data-id="element-10162">
                      <MessageCircle size={18} className="text-gray-400" data-id="element-10163" />
                      <span className="text-xs" data-id="element-10164">{post.comments}</span>
                    </button>
                    <button className="flex items-center gap-1" data-id="element-10165">
                      <Share2 size={18} className="text-gray-400" data-id="element-10166" />
                      <span className="text-xs" data-id="element-10167">Share</span>
                    </button>
                  </div>
                  <button className="flex items-center gap-1" data-id="element-10168">
                    <Gift size={18} className="text-purple-400" data-id="element-10169" />
                    <span className="text-xs" data-id="element-10170">Gift</span>
                  </button>
                </div>
                <div className="flex items-center gap-1 mt-2" data-id="element-10171">
                  <div className="flex -space-x-2" data-id="element-10172">
                    <div className="w-5 h-5 rounded-full border border-gray-900 bg-gray-700" data-id="element-10173"></div>
                    <div className="w-5 h-5 rounded-full border border-gray-900 bg-gray-700" data-id="element-10174"></div>
                  </div>
                  <span className="text-xs text-gray-400" data-id="element-10175">
                    Liked by Michael and {(post.likes - 1).toLocaleString()}{' '}
                    others
                  </span>
                </div>
                <div className="text-xs text-gray-400 mt-1" data-id="element-10176">
                  View all {post.comments} comments
                </div>
              </div>
            </div>) : <div className="bg-gray-900 rounded-xl border border-gray-800 p-8 text-center" data-id="element-10177">
            <div className="w-16 h-16 mx-auto flex items-center justify-center bg-gray-800 rounded-full mb-4" data-id="element-10178">
              {activeTab === 'media' ? <ImageIcon size={24} className="text-gray-600" data-id="element-10179" /> : activeTab === 'voice' ? <Mic size={24} className="text-gray-600" data-id="element-10180" /> : activeTab === 'shop' ? <ShoppingBag size={24} className="text-gray-600" data-id="element-10181" /> : <Heart size={24} className="text-gray-600" data-id="element-10182" />}
            </div>
            <h3 className="text-lg font-bold mb-2" data-id="element-10183">
              No {activeTab} content yet
            </h3>
            <p className="text-gray-400 max-w-md mx-auto" data-id="element-10184">
              Mia hasn't posted any {activeTab} content yet. Check back soon!
            </p>
          </div>}
      </div>

      {/* Mission Card */}
      <div className="bg-gradient-to-r from-pink-900/30 to-purple-900/30 rounded-xl border border-pink-800/50 p-4 shadow-md hover:shadow-xl hover:shadow-pink-600/5 transition-all duration-300" data-id="element-10185">
        <div className="flex items-center gap-3" data-id="element-10186">
          <div className="w-10 h-10 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-10187">
            🔥
          </div>
          <div data-id="element-10188">
            <h3 className="font-medium" data-id="element-10189">Daily Mission</h3>
            <p className="text-sm text-gray-300" data-id="element-10190">Like 3 of Mia's posts</p>
          </div>
        </div>
        <div className="mt-3" data-id="element-10191">
          <div className="flex items-center justify-between mb-1" data-id="element-10192">
            <span className="text-xs text-gray-400" data-id="element-10193">Progress</span>
            <span className="text-xs text-gray-400" data-id="element-10194">
              {Object.values(likedPosts).filter(Boolean).length}/3
            </span>
          </div>
          <div className="h-2 bg-gray-700 rounded-full overflow-hidden" data-id="element-10195">
            <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{
            width: `${Math.min(Object.values(likedPosts).filter(Boolean).length / 3 * 100, 100)}%`
          }} data-id="element-10196"></div>
          </div>
        </div>
        <div className="flex items-center justify-between mt-3" data-id="element-10197">
          <div className="flex items-center gap-1" data-id="element-10198">
            <span className="text-pink-400" data-id="element-10199">💗</span>
            <span className="text-sm" data-id="element-10200">+20</span>
          </div>
          <button className="text-xs px-3 py-1.5 bg-pink-500 rounded-full text-white font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" data-id="element-10201">
            View Posts
          </button>
        </div>
      </div>

      {/* Unlock Modal */}
      {showUnlockModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-10202">
          <div className="w-full max-w-sm bg-gray-900 rounded-xl border border-gray-800 overflow-hidden animate-in zoom-in-90 duration-300 shadow-2xl" data-id="element-10203">
            <div className="p-4 border-b border-gray-800" data-id="element-10204">
              <h3 className="font-bold" data-id="element-10205">Unlock Premium Content</h3>
            </div>
            <div className="p-4" data-id="element-10206">
              <p className="text-sm text-gray-300 mb-4" data-id="element-10207">
                Unlock this exclusive content from Mia for 8 gems. This is a
                one-time purchase.
              </p>
              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-10208">
                <div className="w-16 h-16 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center text-2xl" data-id="element-10209">
                  💎
                </div>
              </div>
              <div className="flex items-center justify-between mb-4" data-id="element-10210">
                <span className="text-sm" data-id="element-10211">Your balance:</span>
                <span className="font-bold" data-id="element-10212">15 💎</span>
              </div>
              <div className="flex items-center justify-between mb-4" data-id="element-10213">
                <span className="text-sm" data-id="element-10214">Cost:</span>
                <span className="font-bold text-pink-400" data-id="element-10215">-8 💎</span>
              </div>
              <div className="flex gap-2" data-id="element-10216">
                <button className="flex-1 py-2 bg-gray-800 rounded-lg text-sm hover:bg-gray-700 transition-colors" onClick={() => setShowUnlockModal(false)} data-id="element-10217">
                  Cancel
                </button>
                <button className="flex-1 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={confirmUnlock} data-id="element-10218">
                  Unlock Now
                </button>
              </div>
            </div>
          </div>
        </div>}

      {/* Image Generation Modal */}
      {showImageGeneratorModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-10219">
          <div className="w-full max-w-md bg-white rounded-xl border border-gray-200 overflow-hidden animate-in zoom-in-90 duration-300 shadow-2xl" data-id="element-10220">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-10221">
              <h3 className="font-bold text-gray-800" data-id="element-10222">
                Generate Image with Mia
              </h3>
              <button onClick={() => setShowImageGeneratorModal(false)} className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200" data-id="element-10223">
                <X size={18} className="text-gray-500" data-id="element-10224" />
              </button>
            </div>
            <div className="p-4" data-id="element-10225">
              <p className="text-sm text-gray-600 mb-4" data-id="element-10226">
                Create a custom image with Mia. Choose your options and generate
                a unique image.
              </p>
              <div className="space-y-4" data-id="element-10227">
                <div data-id="element-10228">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-10229">
                    Style
                  </label>
                  <select className="w-full bg-white border border-gray-300 rounded-lg p-2 text-sm text-gray-800" data-id="element-10230">
                    <option data-id="element-10231">Sports Fan</option>
                    <option data-id="element-10232">Casual</option>
                    <option data-id="element-10233">Glamour</option>
                    <option data-id="element-10234">Beach</option>
                    <option data-id="element-10235">Workout</option>
                  </select>
                </div>
                <div data-id="element-10236">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-10237">
                    Mood
                  </label>
                  <select className="w-full bg-white border border-gray-300 rounded-lg p-2 text-sm text-gray-800" data-id="element-10238">
                    <option data-id="element-10239">Playful</option>
                    <option data-id="element-10240">Seductive</option>
                    <option data-id="element-10241">Happy</option>
                    <option data-id="element-10242">Mysterious</option>
                    <option data-id="element-10243">Intense</option>
                  </select>
                </div>
                <div data-id="element-10244">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-10245">
                    Special Request
                  </label>
                  <textarea className="w-full bg-white border border-gray-300 rounded-lg p-2 text-sm h-20 text-gray-800" placeholder="Describe what you'd like to see..." data-id="element-10246"></textarea>
                </div>
              </div>
              <div className="mt-6" data-id="element-10247">
                <div className="flex items-center justify-between mb-4" data-id="element-10248">
                  <span className="text-sm text-gray-700" data-id="element-10249">Cost:</span>
                  <span className="font-bold text-pink-500" data-id="element-10250">15 💎</span>
                </div>
                <div className="flex gap-2" data-id="element-10251">
                  <button className="flex-1 py-2 bg-gray-100 rounded-lg text-sm text-gray-800 hover:bg-gray-200 transition-colors" onClick={() => setShowImageGeneratorModal(false)} data-id="element-10252">
                    Cancel
                  </button>
                  <button className="flex-1 py-2 bg-pink-600 rounded-lg text-white text-sm font-medium hover:bg-pink-700 transition-colors" data-id="element-10253">
                    Generate Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {/* Video Generation Modal */}
      {showVideoUpsellModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-10254">
          <VideoGenerationUpsell onClose={() => setShowVideoUpsellModal(false)} onPurchase={(duration, tokens) => {
        // Handle purchase logic
        setShowVideoUpsellModal(false);
      }} data-id="element-10255" />
        </div>}

      <style jsx data-id="element-10256">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .angel-feed-container {
          max-width: 860px;
          margin: 0 auto;
          padding: 0 16px;
        }
        @media (min-width: 1440px) {
          .angel-feed-container {
            max-width: 1080px;
          }
        }
        .angel-feed-post {
          max-width: 820px;
          margin: 0 auto;
        }
        .angel-post-image {
          width: 100%;
          height: auto;
          object-fit: cover;
          image-rendering: auto;
          border-radius: 0;
        }
        .image-high-quality {
          image-rendering: auto;
        }
      `}</style>
    </section>;
};